module.exports = __webpack_public_path__ + "static/twitter-logo-button-e0a939b83d966c5c061ce60756bcbaf1.png";